export function normalizeSerial(serial) {
  return serial.replace(/[-\s]/g, "_").toUpperCase().replace("TEST", "test");
}
